/**
 * OperationalBundleViewerRoute
 *
 * Standalone route for the independent Operational Bundle Viewer.
 * Route: /verify/operational-bundle
 */

import React from 'react';
import { OperationalBundleViewer } from '../operationalBundleViewer/OperationalBundleViewer.js';

export const OperationalBundleViewerRoute: React.FC = () => {
  return <OperationalBundleViewer />;
};
